"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextStatic = void 0;
var ContextStatic = /** @class */ (function () {
    function ContextStatic() {
    }
    ContextStatic.boot = function (opts) {
        this.apiInstance = opts.api;
        this._isBooted = true;
    };
    Object.defineProperty(ContextStatic, "default", {
        get: function () {
            if (!this._isBooted) {
                throw new Error('It seems like you forgot to call `ContextStatic.boot`. Please call this method at a global level in your application.');
            }
            return {
                apiService: this.apiInstance,
            };
        },
        enumerable: false,
        configurable: true
    });
    ContextStatic._isBooted = false;
    return ContextStatic;
}());
exports.ContextStatic = ContextStatic;
